<label class="input-title" [attr.for]="for">
  <ng-content></ng-content>
  @if (required) {
    <span class="input-title__required"> *</span>
  }
</label>
